import script from "./AreaBox.vue?vue&type=script&setup=true&lang=js"
export * from "./AreaBox.vue?vue&type=script&setup=true&lang=js"

import "./AreaBox.vue?vue&type=style&index=0&id=5b84db9c&lang=less&scoped=true"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b84db9c"]])

export default __exports__